import home from './components/home.vue'
import NotFoundComponent from './components/404.vue'
import consultation from './components/children/consultation.vue'
import aboutme from './components/children/aboutme.vue'
import contactus from './components/children/contactus.vue'
import VueRouter from 'vue-router'
const router = new VueRouter({
  routes: routers
});
const routers = [
  {
    path: '/',
    name: 'home',
    component: home
  },
  {
    path: '/consultation',
    name: 'consultation',
    component: consultation
  },
  {
    path: '/aboutme',
    name: 'aboutme',
    component: aboutme
  },
  {
    path: '/contactus',
    name: 'contactus',
    component: contactus
  },
  { path: '*', component: NotFoundComponent }
];
export default routers



// WEBPACK FOOTER //
// ./src/routers.js